import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { genericTexts } from '@utils/translations/en';
import CascadeLoader from '../CascadeLoader/CascadeLoader';

type FullPageLoaderProps = {
  hasSideNav?: boolean;
};

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ hasSideNav = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          zIndex: isMobile ? 1001 : 9988,
          width: isMobile ? '100%' : '400px',
          height: '300px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          top: 'calc(50% - 150px)',
          left: isMobile ? 0 : 'calc(50% - 100px)',
        }}
      >
        <Box
          sx={{
            width: '15rem',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CascadeLoader />
        </Box>
        <p
          style={{
            paddingLeft: isMobile ? '1rem' : 0,
            paddingRight: isMobile ? '1rem' : 0,
            paddingTop: '3rem',
            textAlign: 'center',
          }}
        >
          {genericTexts.pleaseWait}
        </p>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          zIndex: 1000,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: theme.palette.common.white,
          opacity: '1',
        }}
      />
    </>
  );
};

export default FullPageLoader;
